<template>
  <button type="button" class="btn btn-dark btn-sm btn-passenger" @click="show = true" :class="passengerClasses(passenger)">{{ passenger.given_names }} {{ passenger.surname }}</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Passenger</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <form ref="editPassenger">
            <Passenger :passenger="form" />
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-outline-danger" @click="destroy()">Delete Passenger</button>
          <button type="button" class="btn btn-primary" @click="addToPassengers()">Save Passenger</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import Passenger from '@/components/Form/Passenger'
export default {
  name: 'EditPassenger',
  components: {
    Passenger
  },
  props: ['passenger', 'customers'],
  data() {
    return {
      show: false,
      form: this.$inertia.form({
        customers_id: this.customers.id,
        sex: this.passenger.sex,
        given_names: this.passenger.given_names,
        surname: this.passenger.surname,
        dob: this.passenger.dob,
        nationality: this.passenger.nationality,
        passport_number: this.passenger.passport_number,
        passport_issue: this.passenger.passport_issue,
        passport_expire: this.passenger.passport_expire,
      }),
    }
  },
  methods: {
    passengerClasses(passenger) {
      return {
        expired: Date.parse(passenger.passport_expire) - Date.parse(new Date()) < 0
      }
    },
    destroy() {
      if (confirm('Are you sure you want to delete this passenger?')) {
        this.$inertia.delete(`/passengers/${this.passenger.id}`)
      }
    },
    addToPassengers() {
      this.form.put(`/passengers/${this.passenger.id}`)
      this.show = false;
    }
  }
}
</script>

<style>
.modal.show {
  display: block;
}
</style>
